/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DragOutlined } from '@ant-design/icons';
import session from 'containers/App/session';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { DOMAIN } from '../../../../SellingRateCalendarPage/state/constants';
import { useInjectSaga } from '../../../../../utils/redux/injectSaga';
import { useInjectReducer } from '../../../../../utils/redux/injectReducer';
import reducer from '../../../../SellingRateCalendarPage/state/reducer';
import saga from '../../../../SellingRateCalendarPage/state/saga';
import { Header, HeaderContainer, DragContainer, ScrollableBody } from '../../../../DashboardPage/GridComponents';
import messages from './messages';
import { statsService } from '../../../../../utils/api';
import Table from '../../../../../components/Table';
import { groupBy, isEmpty, uniq } from 'lodash';
import { Skeleton } from 'antd';
import '../../accountManagement.css';
import { downloadExcel } from '../../../../../utils/fileDownload';
import Button from '../../../../../components/forms/Button';
import Select from 'components/forms/Select';
import { makeColumnFilteringProps } from '../../shared';

const { Column } = Table;

const Users = ({ isDraggable, token, propertyUuids, individualPropertyID }) => {
    useInjectReducer({ key: DOMAIN, reducer });
    useInjectSaga({ key: DOMAIN, saga });
    const intl = useIntl();
    const [fetching, setFetching] = useState(false);
    const [fetchingExport, setFetchingExport] = useState(false);
    const [fetched, setFetched] = useState(false);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [formattedData, setFormattedData] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [vendorIds, setVendorIds] = useState([]);
    const propertyId = useSelector(session.selectors.selectSelectedPropertyId);

    const dragContainer = isDraggable && (
        <DragContainer className="draggable-item">
            <DragOutlined />
        </DragContainer>
    );

    const formatData = () => {
        const groupedByEmail = groupBy(filteredData, 'email');
        const newData = [];
        setFormattedData([]);
        Object.entries(groupedByEmail).forEach(([key, value]) => {
            if (!isEmpty(value)) {
                const { firstName, lastName } = value[0];
                newData.push({
                    name: `${firstName} ${lastName}`,
                    email: key,
                    properties: value.map((i) => i.propertyName).toString(),
                    pms: uniq(value.map((i) => i.pms)).toString(),
                });
            }
        });
        setFormattedData([...newData]);
    };

    const loadData = async () => {
        setFetching(true);
        setFetched(false);
        let response = [];
        if (individualPropertyID) {
            response = await statsService({
                token,
            }).getAccountManagementUsers({ propertyID: individualPropertyID });
        } else {
            response = await statsService({
                token,
            }).getAccountManagementUsers();
        }
        let users = response?.data || [];
        if (!isEmpty(propertyUuids)) {
            users = users.filter(({ propertyUuid }) => propertyUuids.includes(propertyUuid));
        }
        setData(users);
        setFilteredData(users);
        response = await statsService({
            token,
        }).getAccountManagementVendors();
        setVendors(response?.data || []);
        setFetching(false);
        setFetched(true);
    };

    const onExportData = async () => {
        setFetchingExport(true);
        const params = {
            vendorIds,
            propertyUuids,
        };
        if (individualPropertyID) {
            params.propertyUuids = [individualPropertyID];
        }
        const excelFile = await statsService({
            token,
            propertyId,
        }).getUsersReport(params);

        downloadExcel(excelFile.data, `users.xlsx`);
        setFetchingExport(false);
    };

    const onChangePmsFilter = (val) => {
        setVendorIds(val);
        if (!isEmpty(val)) {
            setFilteredData([...data.filter((d) => val.includes(d.vendorId))]);
        } else {
            setFilteredData([...data]);
        }
    };

    useEffect(() => {
        loadData();
    }, [propertyUuids]);

    useEffect(() => {
        formatData();
    }, [filteredData]);

    return (
        <>
            <HeaderContainer>
                <Header>{intl.formatMessage(messages.title)}</Header>
                {dragContainer}
            </HeaderContainer>
            <ScrollableBody>
                {fetching && (
                    <>
                        <Skeleton active />
                        <Skeleton active />
                        <Skeleton active />
                    </>
                )}
                {!fetching && fetched && (
                    <>
                        {!individualPropertyID && (
                            <Select
                                placeholder="PMS Filter"
                                mode="multiple"
                                onChange={onChangePmsFilter}
                                style={{
                                    width: 'max-content',
                                    minWidth: '20%',
                                    marginTop: '10px',
                                    marginBottom: '10px',
                                }}
                            >
                                {vendors.map(({ id, handle }) => (
                                    <Select.Option key={id} value={id}>
                                        {handle}
                                    </Select.Option>
                                ))}
                            </Select>
                        )}
                        <Table
                            dataSource={formattedData}
                            pagination={{
                                pageSize: 31,
                                hideOnSinglePage: true,
                            }}
                            rowKey="email"
                            tableLayout="auto"
                            size="small"
                            scroll={{ y: 290 }}
                        >
                            <Column
                                width="25%"
                                dataIndex="name"
                                title={<FormattedMessage {...messages.nameColumnTitle} />}
                                sorter={(a, b) => a.name.localeCompare(b.name)}
                                defaultSortOrder="ascend"
                                {...makeColumnFilteringProps(data, 'name')}
                            />
                            <Column
                                width="25%"
                                dataIndex="email"
                                title={<FormattedMessage {...messages.emailColumnTitle} />}
                                sorter={(a, b) => a.email.localeCompare(b.email)}
                                {...makeColumnFilteringProps(data, 'email')}
                            />
                            {!individualPropertyID && (
                                <>
                                    <Column
                                        width="25%"
                                        dataIndex="properties"
                                        title={<FormattedMessage {...messages.propertyColumnTitle} />}
                                        {...makeColumnFilteringProps(data, 'properties')}
                                    />
                                    <Column
                                        width="25%"
                                        dataIndex="pms"
                                        title={<FormattedMessage {...messages.pmsColumnTitle} />}
                                        {...makeColumnFilteringProps(data, 'pms')}
                                    />
                                </>
                            )}
                        </Table>
                        <div style={{ marginTop: '10px' }}>
                            <Button size="small" onClick={onExportData} loading={fetchingExport}>
                                <FormattedMessage {...messages.exportButton} />
                            </Button>
                        </div>
                    </>
                )}
            </ScrollableBody>
        </>
    );
};

Users.propTypes = {
    token: PropTypes.string.isRequired,
    propertyUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Users;
